const messages = {
  en: {
    home: "Start",
    "react-developer": "Competences",
    servicesInfo: "My services",
    about: "About me",
    kontakt: "Contact",
    "tworzenie-aplikacji-webowych": "Offer",
    offer: "Offer",
    jobtext1: "I love this job",
    "projekty-react": "Projects",
    mynameis: "I'm Michał Jaskulski",
    fullstack: "Full Stack Developer",
    hometext1:
      "I design and create web database applications based on modern technologies.",
    abouttext1: "about me - meybe funny",
    contacttext1: "Form to contact",
    loading: "Loading the data...",
    pagenotfound: "PAGE NOT FOUND",
    faq: "FAQ",
    wspolpraca: "Cooperation",
  },
  pl: {
    home: "Start",
    "react-developer": "Kompetencje",
    servicesInfo: "Co potrafię",
    about: "O mnie",
    kontakt: "Kontakt",
    "tworzenie-aplikacji-webowych": "Oferta",
    offer: "Oferta",
    "projekty-react": "Projekty",
    projectstext1: "I love this job",
    mynameis: "Nazywam się Michał Jaskulski",
    fullstack: "DeVeloper Full Stack",
    hometext1:
      "Zajmuję się projektowaniem i tworzeniem bazodanowych aplikacji w oparciu o nowoczesne technologie.",
    abouttext1: "O mnie - trochę na wesoło",
    contacttext1: "Formularz kontaktowy",
    loading: "Ładowanie danych...",
    pagenotfound: "STRONA NIE ZOSTAŁA ZNALEZIONA",
    faq: "FAQ",
    wspolpraca: "Współpraca",
  },
};
export default messages;
